/**
 * WhatsApp Floating Button
 *
 * Floating action button for quick WhatsApp contact
 * Common in Middle Eastern e-commerce sites
 */

import { MessageCircle, X } from "lucide-react";
import { useState } from "react";
import { socialMediaLinks } from "@/config/socialMedia";

const WhatsAppFloat = () => {
  const [isOpen, setIsOpen] = useState(false);

  if (!socialMediaLinks.whatsapp.enabled) {
    return null;
  }

  const handleWhatsAppClick = () => {
    window.open(socialMediaLinks.whatsapp.url, '_blank', 'noopener,noreferrer');
    setIsOpen(false);
  };

  return (
    <>
      {/* Floating Button */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
        {/* Tooltip/Message bubble */}
        {isOpen && (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-4 max-w-xs animate-in slide-in-from-bottom-2 duration-200">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              aria-label="Close"
            >
              <X className="h-4 w-4" />
            </button>
            <div className="flex items-start gap-3 pr-6">
              <div className="h-12 w-12 rounded-full bg-green-600 flex items-center justify-center flex-shrink-0">
                <MessageCircle className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm mb-1">Need help?</p>
                <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
                  Chat with us on WhatsApp! We typically reply within minutes.
                </p>
                <button
                  onClick={handleWhatsAppClick}
                  className="bg-green-600 hover:bg-green-700 text-white text-xs px-4 py-2 rounded-full transition-colors"
                >
                  Start Chat
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Main WhatsApp Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="h-14 w-14 rounded-full bg-green-600 hover:bg-green-700 text-white shadow-2xl hover:shadow-green-600/50 transition-all duration-200 flex items-center justify-center group relative"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="h-7 w-7 group-hover:scale-110 transition-transform" />

          {/* Notification badge (optional - can be enabled when needed) */}
          {/* <span className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 rounded-full text-[10px] font-bold flex items-center justify-center">
            1
          </span> */}

          {/* Pulse animation */}
          <span className="absolute inset-0 rounded-full bg-green-600 animate-ping opacity-20"></span>
        </button>
      </div>
    </>
  );
};

export default WhatsAppFloat;
